"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const defaultConfig_1 = require("./defaultConfig");
const GTM_ID_REGEX = /^GTM-[0-9A-Z]+$/;
class GTManager {
    constructor(options) {
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isBrowserContext", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => typeof window !== 'undefined'
        });
        this.options = { ...defaultConfig_1.defaultConfig, ...options };
        try {
            this.assertIsGtmId(this.options.gtmId);
            if (this.options.autoInit) {
                this.init();
            }
        }
        catch (e) {
            if (typeof e === 'string') {
                (0, utils_1.showWarn)(e);
            }
            else if (e instanceof Error) {
                (0, utils_1.showWarn)(e.message);
            }
        }
    }
    assertIsGtmId(id) {
        if (!id || typeof id !== 'string' || !GTM_ID_REGEX.test(id)) {
            (0, utils_1.throwError)(`GTM id='${id}' is not valid`);
        }
    }
    hasScript() {
        return Array.from(document.getElementsByTagName('script')).some((script) => script.src.includes('googletagmanager.com/gtm.js'));
    }
    init() {
        if (this.hasScript()) {
            (0, utils_1.showWarn)('The script is already loaded');
            return;
        }
        if (!this.isBrowserContext()) {
            (0, utils_1.throwError)('Currently, library works only in browser');
        }
        window.dataLayer = window.dataLayer || [];
        this.loadScript(this.options.gtmId);
        this.loadIFrame(this.options.gtmId);
        window.dataLayer.push({
            event: 'gtm.js',
            'gtm.start': new Date().getTime(),
        });
    }
    loadScript(id) {
        const head = document.head;
        const doc = window.document;
        const script = doc.createElement('script');
        script.async = true;
        script.defer = false;
        script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
        head.insertBefore(script, head.firstChild);
    }
    loadIFrame(id) {
        const noScript = document.createElement('noscript');
        noScript.insertAdjacentHTML('afterbegin', `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>`);
        document.body.insertBefore(noScript, document.body.firstChild);
    }
    pushEvent(event, eventData = {}) {
        var _a;
        window.dataLayer = (_a = window.dataLayer) !== null && _a !== void 0 ? _a : [];
        window.dataLayer.push({
            event,
            ...eventData,
        });
    }
    trackView(screenName, path, additionalEventData = {}) {
        this.pushEvent('virtualPageView', {
            pageLocation: window.location.href,
            pageTitle: screenName,
            pagePath: path,
            ...additionalEventData,
        });
    }
}
exports.default = GTManager;
